import {
    IconButton,
    IconButtonSizes,
    IconButtonStyles,
    Icons,
    LayoutCarousel,
    Tooltip
} from '@silverfort/sf-components';
import { PolicyCountByStatus } from '../../types';

type MfaPolicyCarouselProps = {
    title: string;
    policies?: PolicyCountByStatus;
    isLoading: boolean;
    selectedStatus: keyof PolicyCountByStatus;
    onStatusChange: (value: keyof PolicyCountByStatus) => void;
    onIconClick: () => void;
};

const MfaPolicyCarousel = ({
    policies,
    isLoading,
    selectedStatus,
    onStatusChange,
    onIconClick,
    title
}: MfaPolicyCarouselProps) => {
    return (
        <LayoutCarousel
            title={title}
            contentClassName="py-2 flex flex-1 flex-col justify-center [&]:items-start group"
            dropDownProps={{
                variant: 'trigger',
                items: [
                    { title: 'All', value: 'total' },
                    { title: 'Active', value: 'active' },
                    { title: 'Disabled', value: 'disabled' }
                ],
                size: 'large',
                width: '100px',
                className: '[&]:w-[100px] border [&]:border-sf-gray-100 bg-transparent',
                selectedItems: selectedStatus,
                onChange: (value) => onStatusChange(value as keyof PolicyCountByStatus)
            }}
            pages={
                <div className="flex flex-row gap-2 px-2 w-full">
                    {isLoading ? (
                        <div className="h-6 w-[112px] animate-pulse rounded-sm bg-sf-gray-50"></div>
                    ) : (
                        <div className="flex flex-row justify-between w-full items-center">
                            <span className="text-16 font-bold">{policies?.[selectedStatus]?.toLocaleString()}</span>
                            <div>
                                <Tooltip title="Go to policies">
                                    <IconButton
                                        className="opacity-0 group-hover:opacity-100 cursor-pointer"
                                        sizeVariant={IconButtonSizes.Large}
                                        buttonStyle={IconButtonStyles.Primary}
                                        iconSize={16}
                                        icon={Icons.OpenInNew}
                                        onClick={onIconClick}
                                    />
                                </Tooltip>
                            </div>
                        </div>
                    )}
                </div>
            }
        />
    );
};

export default MfaPolicyCarousel;
